import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import { getAccessToken } from '@medeo/user'

const ProtectedRoute = ({ component: Component, token, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      token !== null ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: '/login',
            state: { from: props.location }
          }}
        />
      )
    }
  />
)

const mapStateToProps = state => ({
  token: getAccessToken(state)
})

export default connect(mapStateToProps)(ProtectedRoute)



// WEBPACK FOOTER //
// ./src/LogIn/containers/ProtectedRoute.js